<template>
  <div id="baiduMap" style="width: 100%; height: calc(100vh - 100px); background-color: black;"></div>
</template>

<script>
import dixing from '@/assets/origin_dixing.png'
export default {
  name: 'BaiduMap',
  data() {
    return {
      map: {}
    }
  },
  mounted() {
    this.initMap();
  },
  methods: {
    setSegments(segments) {
      const map = this.map;
      this.map.clearOverlays();
      for (var i = 0; i < segments.length; i++) {
        const segment = segments[i];
        var point = new BMapGL.Point(segment.longitude, segment.latitude);
        var content = segment.name;
        var label = new BMapGL.Label(content, {       // 创建文本标注
          position: point,                          // 设置标注的地理位置
          // offset: new BMapGL.Size(10, 20)           // 设置标注的偏移量
        })
        label.setStyle({                              // 设置label的样式
          // color: '#000',
          fontSize: '12px',
          border: 'none',
          background: 'none'
        })
        map.addOverlay(label);                        // 将标注添加到地图中


        var marker = new BMapGL.Marker(point); // 创建标注
        map.addOverlay(marker); // 将标注添加到地图中
        if(segment.use_photo){
          // 创建叠加物显示的范围Bounds
          var pStart = new BMapGL.Point(segment.image_top_left_longitude, segment.image_top_left_latitude);
          var pEnd = new BMapGL.Point(segment.image_bottom_right_longitude, segment.image_bottom_right_latitude);
          var bounds = new BMapGL.Bounds(new BMapGL.Point(pStart.lng, pEnd.lat),
            new BMapGL.Point(pEnd.lng, pStart.lat));
          // 创建地面叠加层实例
          var imgOverlay = new BMapGL.GroundOverlay(bounds, {
            type: 'image',
            url: segment.image_url,
            opacity: 0.8
          });
          // 叠加层添加到地图
          map.addOverlay(imgOverlay);
        }
        
      }
      if(segments.length > 0) {
        const segment = segments[0];
        this.go(segment.longitude, segment.latitude, 20);
      }
    },
    initMap() {
      // 地图初始化逻辑
      const map = new BMapGL.Map('baiduMap');
      this.map = map;
      var opts = {
        offset: new BMapGL.Size(420, 30),
        anchor: BMAP_ANCHOR_BOTTOM_LEFT
      }
      var cityCtrl = new BMapGL.CityListControl(opts);  // 添加城市列表控件
      map.addControl(cityCtrl);
      // 启用鼠标滚轮缩放
      map.enableScrollWheelZoom(true);
      map.setMapStyleV2({
        styleId: '6d1490feebd852dabf3ee07d0643efd5'
      });
      return map;
    },
    go(lng, lat, level) {
      const point = new BMapGL.Point(lng, lat); // 使用您的坐标
      this.map.centerAndZoom(point, level || 20);
    }
  }
}
</script>

<style lang="less">
</style>
